
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormatTimeModule } from '@go-modules/pipes/format-time/format-time.module';
import { ThumbnailComponent } from './thumbnail.component';
import { BadgeModule } from '@go-modules/components/badge/badge.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		FormatTimeModule,
		BadgeModule
	],
	declarations: [
		ThumbnailComponent
	],
	exports: [
		ThumbnailComponent
	]
})
export class ThumbnailModule {}
